import { AxiosResponse } from 'axios'
import { queryOptions } from '@tanstack/react-query'
import { createUrl } from './helpers'
import axiosAuth from './config'
import { NFacilities } from '../interfaces/services/facilities.interfaces'

export const getFacilitiesPerSociety = (
  societyId: string
): Promise<AxiosResponse<NFacilities.NGetPerSocieties.IResponse>> => {
  const body: NFacilities.NGetPerSocieties.IRequestBody = {
    societyIds: [societyId],
  }
  return axiosAuth.post<NFacilities.NGetPerSocieties.IResponse>(
    createUrl('/facilities/get-per-societies/'),
    body
  )
}

export const createFacility = (
  body: NFacilities.NCreate.IRequestBody
): Promise<AxiosResponse<NFacilities.NCreate.IResponse>> => {
  return axiosAuth.post<NFacilities.NCreate.IResponse>(
    createUrl(`/facilities/facility`),
    body
  )
}

export const patchFacility = (variables: {
  id: string
  body: NFacilities.NPatch.IRequestBody
}): Promise<AxiosResponse<NFacilities.NPatch.IResponse>> => {
  return axiosAuth.patch<NFacilities.NPatch.IResponse>(
    createUrl(`/facilities/facility/${variables.id}`),
    variables.body
  )
}

export const getFacility = (
  id: string
): Promise<AxiosResponse<NFacilities.NGetById.IResponse>> => {
  return axiosAuth.get<NFacilities.NGetById.IResponse>(
    createUrl(`/facilities/facility/${id}`)
  )
}

export const deleteFacility = (
  id: string
): Promise<AxiosResponse<NFacilities.NDel.IResponse>> => {
  return axiosAuth.delete<NFacilities.NDel.IResponse>(
    createUrl(`/facilities/facility/${id}`)
  )
}

export const facilityQueries = {
  getFacility: (facilityId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'facilities', entity: 'detail', facilityId }],
      queryFn: async ({ queryKey }) => {
        return (await getFacility(queryKey[0].facilityId!)).data.data
      },
      enabled: !!facilityId,
    }),
  getFacilitiesPerSociety: (societyId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'facilities', entity: 'list', societyId }],
      queryFn: async ({ queryKey }) => {
        return (await getFacilitiesPerSociety(queryKey[0].societyId!)).data.data
      },
      enabled: !!societyId,
    }),
}
